"use client";

import React, { useState, useEffect } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Clock, ArrowRight } from "lucide-react";
export default function SeasonSpecials() {
  const [timeLeft, setTimeLeft] = useState({
    days: 4,
    hours: 12,
    minutes: 30,
    seconds: 45
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          days,
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds--;
        } else {
          seconds = 59;
          if (minutes > 0) {
            minutes--;
          } else {
            minutes = 59;
            if (hours > 0) {
              hours--;
            } else {
              hours = 23;
              if (days > 0) {
                days--;
              }
            }
          }
        }
        return {
          days,
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (value: number) => value.toString().padStart(2, "0");
  return <section data-section-id="179055" id="awaken-the-senses" className="dark bg-background text-foreground relative w-full min-h-[80vh] flex items-center justify-center overflow-hidden border-y border-secondary/40">
      {}
      <div className="absolute inset-0 z-0">
        <video autoPlay loop muted playsInline className="w-full h-full object-cover scale-105" poster="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624786/img/incense_smoke_bg.png">
          {}
          <source src="https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4" type="video/mp4" />
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624786/img/incense_smoke_bg.png" alt="Incense Smoke Background" className="w-full h-full object-cover" />
        </video>
        
        {}
        <div className="absolute inset-0 bg-background/80 mix-blend-multiply" />
        <div className="absolute inset-0 bg-gradient-to-t from-background via-background/60 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-r from-background/90 via-transparent to-background/90" />
      </div>

      {}
      <div className="relative z-10 container mx-auto px-4 flex flex-col items-center text-center">
        
        {}
        <div className="mb-8 animate-in fade-in slide-in-from-bottom-4 duration-700 delay-100">
          <Badge variant="outline" className="border-[#a855f7] bg-background/60 backdrop-blur-md text-foreground py-2 px-4 text-sm md:text-base gap-3 shadow-[0_0_15px_var(--color-primary)]/10 font-default">
            <Clock className="w-4 h-4 text-primary" />
            <span className="font-semibold tracking-wider uppercase text-xs md:text-sm">Presence Begins In</span>
            <div className="flex items-center gap-1 font-mono font-bold text-primary">
              <span>{formatTime(timeLeft.days)}d</span>
              <span className="opacity-50">:</span>
              <span>{formatTime(timeLeft.hours)}h</span>
              <span className="opacity-50">:</span>
              <span>{formatTime(timeLeft.minutes)}m</span>
              <span className="opacity-50">:</span>
              <span>{formatTime(timeLeft.seconds)}s</span>
            </div>
          </Badge>
        </div>

        {}
        <h2 className="text-6xl md:text-8xl lg:text-9xl font-default font-bold tracking-tighter text-white mb-6 uppercase drop-shadow-2xl animate-in fade-in zoom-in-95 duration-1000">
          Bring the <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-primary/60">Sanctuary</span> Home.
        </h2>

        {}
        <p className="text-lg md:text-2xl text-white/80 max-w-2xl mb-10 font-serif font-medium tracking-wide drop-shadow-md animate-in fade-in slide-in-from-bottom-6 duration-700 delay-300">
          Elevate your frequency with curated tools for the soul. Explore our collection of high-vibration incense, ritual wear, and sacred objects designed for modern presence.
        </p>

        {}
        <div className="animate-in fade-in slide-in-from-bottom-8 duration-700 delay-500">
          <Button asChild size="lg" className="h-14 px-8 text-lg font-default font-semibold bg-gradient-to-br from-primary via-primary to-primary/80 text-primary-foreground hover:bg-primary/90 shadow-[0_0_30px_var(--color-primary)]/40 hover:shadow-[0_0_40px_var(--color-primary)]/60 transition-all duration-300 group backdrop-blur-sm">
            <Link to="#">
              Shop the Collection
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Link>
          </Button>
        </div>

      </div>
    </section>;
}